<!-- <div class="main-section">
    <div class="title">
        <title>Website Settings</title>
    </div>
        <mat-form-field appearance="outline" class="gst-input-field">
            <mat-label>GST Number (Optional)</mat-label>
            <input matInput formControlName="gstNumber" (input)="validateGstInput()" maxlength="15">
        </mat-form-field>
</div> -->


<div class="my-request">
    <!-- <mat-progress-bar class="mt-8" mode="indeterminate"></mat-progress-bar> -->
    <div class="container">
      <div class="main-content">
        <h2 class="title">Website Settings</h2>
        <div class="SearchBarPlaceholder">
            <div class="search">

      </div>
      <div class="input-container">
        <form [formGroup] = "websiteSettings">
            <mat-form-field appearance="outline" class="gst-input-field">
                <mat-label>WebSite</mat-label>
                <input matInput formControlName="website">
                <mat-error *ngIf="websiteSettings.get('website')?.hasError('pattern')">
                  Please enter a valid website URL.
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="gst-input-field">
                <mat-label>Facebook Url</mat-label>
                <input matInput formControlName="facebookUrl">
                <mat-error *ngIf="websiteSettings.get('facebookUrl')?.hasError('pattern')">
                  Please enter a valid Facebook URL.
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="gst-input-field">
                <mat-label>Instagram Url</mat-label>
                <input matInput formControlName="instagramUrl">
            </mat-form-field>
            <mat-card appearance="outlined" class="upload-card" style="margin-bottom: 40px;">
                <div class="card-header">
                  <p class="add-img" style="font-size:12px">Add Images</p>
                  <mat-icon class="camera" (click)="openPopUp()">photo_camera</mat-icon>
                </div>
                <!-- Display Selected Image Previews -->
                <div class="image-preview-container">
                  <div *ngIf="newlyUploadedImages?.length === 0" class="no-image-text">
                    <p>No image selected</p>
                  </div>
                  <div class="image-wrapper" *ngFor="let image of newlyUploadedImages; let i = index">
                    <button mat-icon-button class="delete-icon" style="margin-top: -14px;" (click)="removeImage(image)">
                      <mat-icon color="warn">close</mat-icon>
                    </button>
                    <img
                      [src]="image.url"
                      alt="Selected Image"
                      class="image-preview"
                      (click)="openViewer(i)"
                    />
                    <div class="tag-label">
                        {{ image.tag }}
                      </div>
                  </div>

                </div>

                <!-- <div class="image-viewer" *ngIf="isViewerOpen">
                    <div class="image-container">
                      <button class="close-btn-quote" (click)="closeViewer()">✖</button>
                      <button class="prev-btn-quote" (click)="prevImage1()">&#10094;</button>
                      <img [src]="selectedImage" class="full-image">
                      <button class="next-btn-quote" (click)="nextImage1()">&#10095;</button>
                    </div>
                  </div> -->
              

              </mat-card>
                              <!-- Fullscreen Viewer -->
                              <div class="image-viewer" *ngIf="isViewerOpen">
                                <div class="image-container">
                                  <button class="close-btn-quote" (click)="isViewerOpen = false">
                                    ✖
                                  </button>
                                  <button  class="prev-btn-quote" (click)="prevImage1()" [disabled]="currentIndex === 0">
                                    <!-- <mat-icon>chevron_left</mat-icon> -->
                                    &#10094;
                                  </button>
                                  <img [src]="selectedImage" class="full-image" />
                                  <button class="next-btn-quote" (click)="nextImage1()" [disabled]="currentIndex === newlyUploadedImages.length - 1">
                                    <!-- <mat-icon>chevron_right</mat-icon> -->
                                    &#10095;
                                  </button>
                                </div>
                              </div>
              
              <!-- Upload Popup -->
              <div *ngIf="showUploadPopup" class="popup-overlay">
                <div class="popup">
                  <div class="cancel">
                    <button style="float: right; margin-top: -3%;" mat-icon-button color="warn" (click)="showUploadPopup = false">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                  <h2>Upload Image</h2>
                  <form [formGroup]="imageUpload">
                    <mat-form-field appearance="outline" class="form-field">
                      <mat-label>Name<span class="required-asterisk">*</span></mat-label>
                      <input matInput type="text" formControlName="ImageName" />
                      <mat-error *ngIf="imageUpload.get('ImageName')?.hasError('required')">
                        Name is required.
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                      <mat-label>Select Roles</mat-label>
                      <mat-select [formControl]="roleTypeControl">
                        <mat-option *ngFor="let role of roleTypeList" [value]="role">
                          {{ role.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  
                    <input
                      type="file"
                      #fileInput
                      (change)="onFileSelected($event)"
                      accept="image/*"
                    />
                  
                    <mat-error *ngIf="!selectedFile">
                      Image is required.
                    </mat-error>

                  
                    <div class="popup-actions">
                      <button
                        mat-raised-button
                        class="upload"
                        color="primary"
                        (click)="onUploadClick()"
                      >
                        Upload
                      </button>
                    </div>
                  </form>
                  <!-- <div *ngIf="newlyUploadedImages?.length > 0" class="image-preview-section">
                    <div *ngFor="let img of newlyUploadedImages" class="image-card">
                      <img [src]="img.url" alt="Uploaded Image" width="150" />
                      <p>{{ img.tag }}</p>
                    </div>
                  </div> -->
                  
                  
                </div>
              </div>
              

              <mat-form-field style="margin-bottom:50px;" appearance="outline" class="form-field">
                <mat-label>Insurance Affiliation</mat-label>
                <mat-select
                  [formControl]="insuranceControl"
                  multiple
                  (selectionChange)="onInsuranceSelectionChange()"
                >
                  <mat-option *ngFor="let insurance of insuranceOptions" [value]="insurance">
                    {{ insurance }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              
              
        </form>
      </div>
      <button class="save-btn" (click)="submitData()">Save</button>
        </div>

    </div>
